import React, { useState, useEffect } from 'react';

function DateRangeForm({ onAnalyze, availableStocks, debugLog }) {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [stockFilter, setStockFilter] = useState('');

  useEffect(() => {
    loadDatesFromStorage();
    setupDefaultDates();
  }, []);

  const loadDatesFromStorage = () => {
    const savedStartDate = localStorage.getItem('start_date');
    const savedEndDate = localStorage.getItem('end_date');
    const savedStockFilter = localStorage.getItem('stock_filter');
    
    if (savedStartDate) setStartDate(savedStartDate);
    if (savedEndDate) setEndDate(savedEndDate);
    if (savedStockFilter) setStockFilter(savedStockFilter);
    
    if (debugLog) {
      debugLog('Loaded dates from storage', {
        start_date: savedStartDate,
        end_date: savedEndDate,
        stock_filter: savedStockFilter
      });
    }
  };

  const setupDefaultDates = () => {
    if (!startDate || !endDate) {
      const currentDate = new Date();
      let defaultStartDate;
      
      if (currentDate.getMonth() >= 3) { // April (0-indexed) or later
        defaultStartDate = `${currentDate.getFullYear()}-04-01`;
      } else {
        defaultStartDate = `${currentDate.getFullYear() - 1}-04-01`;
      }
      
      const defaultEndDate = currentDate.toISOString().split('T')[0];
      
      if (!startDate) setStartDate(defaultStartDate);
      if (!endDate) setEndDate(defaultEndDate);
      
      if (debugLog) {
        debugLog('Set default dates', {
          start_date: defaultStartDate,
          end_date: defaultEndDate
        });
      }
    }
  };

  const clearStockFilter = () => {
    setStockFilter('');
    localStorage.removeItem('stock_filter');
    if (debugLog) debugLog('Stock filter cleared');
  };

  const handleStockFilterChange = (e) => {
    const value = e.target.value;
    
    if (debugLog) debugLog('Stock filter input event', value);
    
    // If the user types "All Stocks" or clears the input, treat it as empty
    if (value === 'All Stocks' || value === '') {
      clearStockFilter();
    } else {
      setStockFilter(value);
      localStorage.setItem('stock_filter', value);
      if (debugLog) debugLog('Stock filter changed to', value);
    }
  };

  const handleAnalyze = () => {
    // Save dates and stock filter to local storage
    localStorage.setItem('start_date', startDate);
    localStorage.setItem('end_date', endDate);
    
    if (stockFilter) {
      localStorage.setItem('stock_filter', stockFilter);
    } else {
      localStorage.removeItem('stock_filter');
    }

    // Get tokens from storage
    const sessionToken = localStorage.getItem('zerodha_session_token');
    const apiToken = localStorage.getItem('api_token');
    
    // Call the parent's onAnalyze function
    onAnalyze(sessionToken, apiToken, startDate, endDate, stockFilter);
  };

  return (
    <div className="date-form">
      <h2>Date Range Selection</h2>
      <div className="form-group">
        <label htmlFor="start-date">Start Date:</label>
        <input 
          type="date" 
          id="start-date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />
      </div>
      <div className="form-group">
        <label htmlFor="end-date">End Date:</label>
        <input 
          type="date" 
          id="end-date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />
      </div>
      <div className="form-group">
        <label htmlFor="stock-filter">Stock Filter:</label>
        <div className="filter-container">
          <input 
            type="text" 
            id="stock-filter" 
            list="stock-options" 
            placeholder="Type to search or select a stock"
            value={stockFilter}
            onChange={handleStockFilterChange}
          />
          <datalist id="stock-options">
            <option value="All Stocks" className="all-stocks-option">All Stocks</option>
            {availableStocks && availableStocks.map((stock, index) => (
              <option key={index} value={stock}>{stock}</option>
            ))}
          </datalist>
          <button onClick={clearStockFilter} className="secondary">Clear</button>
        </div>
      </div>
      <div className="form-group">
        <label></label>
        <button id="analyze-button" onClick={handleAnalyze}>Analyze</button>
      </div>
    </div>
  );
}

export default DateRangeForm;
